<template>
    <v-card class="icon-picker" style="box-shadow: none; max-width: 300px">
      <v-card-text style="padding-top: 0px; padding-right: 6px; padding-left: 6px; max-height: 300px; overflow-y: scroll; overflow-x: hidden">
        <v-item-group v-model="selectedIndex" active-class="primary--text">
          <v-container>
            <v-row>
              <v-col cols="6"
                     sm="6"
                     md="4"
                     lg="4" style="padding-right: 0px; margin-bottom: 4px">
                <v-item v-slot="{ active, toggle }" :value="null">
                  <!--v-card--
                      :color="active ? 'primary' : ''"
                      :dark="active"
                      class="d-flex align-center justify-center text-center pa-2"
                      height="60"
                      @click="toggle"
                  >
                    <div>
                      <v-icon large>
                        mdi-cancel
                      </v-icon>
                      <div class="caption mt-1">
                        Kein Icon
                      </div>
                    </div>
                  </v-card-->
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-card
                          v-bind="attrs"
                          :color="active ? 'primary' : ''"
                          :dark="active"
                          class="d-flex align-center justify-center text-center pa-2"
                          height="60"
                          v-on="on"
                          @click="toggle"
                      >
                        <div>
                          <span class="mdi-set v-icon my-icon" style="font-size: 24px;" v-html="`&#xe14b;`"></span>
                          <div class="caption mt-1 text-truncate">
                            {{ 'Kein Symbol' }}
                          </div>
                        </div>
                      </v-card>
                    </template>
                    <span>{{ 'Kein Symbol' }}</span>
                  </v-tooltip>
                </v-item>
              </v-col>

              <v-col
                  v-for="(icon, i) in icons"
                  :key="icon.code_point"
                  cols="6"
                  sm="6"
                  md="4"
                  lg="4"
                  style="padding-right: 0px; margin-bottom: 4px"
              >
                <v-item v-slot="{ active, toggle }" :value="i">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-card
                          v-bind="attrs"
                          :color="active ? 'primary' : ''"
                          :dark="active"
                          class="d-flex align-center justify-center text-center pa-2"
                          height="60"
                          v-on="on"
                          @click="toggle"
                      >
                        <div style="max-width: 100%">
                          <span class="mdi-set v-icon my-icon" style="font-size: 24px;" v-html="`&#x${icon.code_point};`"></span>
                          <div class="caption mt-1 text-truncate">
                            {{ icon.name }}
                          </div>
                        </div>
                      </v-card>
                    </template>
                    <span>{{ icon.name }}</span>
                  </v-tooltip>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
      </v-card-text>
    </v-card>
</template>

<script>
export default {
  name: "CadastreIconPicker",
  props: {
    selectedIcon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedIndex: null,
      icons: [
        // Gebäude und Strukturen
        { name: 'Wohnhaus', code_point: 'e88a' },
        { name: 'Gebäude', code_point: 'ea40' },
        { name: 'Hütte', code_point: 'e587' },
        { name: 'Rathaus', code_point: 'e7f1' },
        { name: 'Geschäft', code_point: 'e8d1' },
        { name: 'Fabrik', code_point: 'ebbc' },
        { name: 'Schule', code_point: 'e80c' },
        { name: 'Kirche', code_point: 'eaae' },
        { name: 'Krankenhaus', code_point: 'e548' },
        { name: 'Feuerwehr', code_point: 'f8f2' },
        { name: 'Hydrant', code_point: 'f1a3' },
        { name: 'Lagerhaus', code_point: 'f569' },
        { name: 'Stadion', code_point: 'eb90' },
        { name: 'Schloss', code_point: 'eab1' },
        { name: 'Friedhof', code_point: 'f364' },

        // Verkehr und Infrastruktur
        { name: 'Straße', code_point: 'f472' },
        { name: 'Wegweiser', code_point: 'f880' },
        { name: 'Ampel', code_point: 'e565' },
        { name: 'Bahn', code_point: 'e533' },
        { name: 'Straßenbahn', code_point: 'e571' },
        { name: 'Bushaltestelle', code_point: 'e530' },
        { name: 'Parkplatz', code_point: 'e54f' },
        { name: 'Tankstelle', code_point: 'e546' },
        { name: 'E-Ladestation', code_point: 'e56d' },
        { name: 'Brücke', code_point: 'e3fc' },
        { name: 'Strom', code_point: 'ea0b' },
        { name: 'Wasser', code_point: 'e798' },
        { name: 'Kraftwerk', code_point: 'e63c' },
        { name: 'Lampe', code_point: 'e42e' },
        { name: 'Fahrradständer', code_point: 'f47b' },
        { name: 'Mülleimer', code_point: 'e872' },
        { name: 'Schachtdeckel', code_point: 'e3a2' },

        // Natur und Erholung
        { name: 'Park', code_point: 'e407' },
        { name: 'Wald', code_point: 'ea99' },
        { name: 'Wiese', code_point: 'f205' },
        { name: 'Naturschutzgebiet', code_point: 'ea35' },
        { name: 'Skigebiet', code_point: 'e513' },
        { name: 'Fußballplatz', code_point: 'ea2f' },
        { name: 'Basketballplatz', code_point: 'ea26' },
        { name: 'Tennisplatz', code_point: 'ea32' },
        { name: 'Schwimmbad', code_point: 'eb48' },
        { name: 'Spielplatz', code_point: 'f5df' },
        { name: 'Kindergarten', code_point: 'eb41' },
        { name: 'Golfplatz', code_point: 'eb45' },
        { name: 'Gewässer', code_point: 'f084' },
        { name: 'Landschaft', code_point: 'e3f7' },
        { name: 'Landwirtschaft', code_point: 'ea79' },
        { name: 'Camping', code_point: 'f8a2' },
        { name: 'WC', code_point: 'e63d' },
        { name: 'Defibrillator', code_point: 'f6e9' },
        { name: 'Grill', code_point: 'ea47' },

        // Allgemeine und vielseitige Icons
        { name: 'Flurstück', code_point: 'ea49' },
        { name: 'Standort-Pin', code_point: 'e55e' },
        { name: 'Ort', code_point: 'e55f' },
        { name: 'Standort hinzufügen', code_point: 'e567' },
        { name: 'Standort bearbeiten', code_point: 'e568' },
        { name: 'Information', code_point: 'e88e' },
        { name: 'Hilfe', code_point: 'e887' },
        { name: 'Warnung', code_point: 'e002' },
        { name: 'Kamera', code_point: 'e3b0' },
        { name: 'Zaun', code_point: 'f1f6' }
      ],
    };
  },
  watch: {
    // Watch for changes in the selected index and emit the corresponding icon object
    selectedIndex(newIndex) {
      // The v-item-group returns `undefined` if nothing is selected.
      // We explicitly check for null or undefined to handle both cases.
      if (newIndex === null || typeof newIndex === 'undefined') {
        this.$emit('input', '');
      } else {
        this.$emit('input', this.icons[newIndex].code_point);
      }
    },

    // Watch for changes in the parent's v-model (the 'value' prop)
    selectedIcon: {
      handler(newValue) {
        if (newValue === null) {
          this.selectedIndex = null;
        } else {
          // Find the index of the icon that matches the incoming value
          const index = this.icons.findIndex(icon => icon.code_point === this.selectedIcon);
          this.selectedIndex = index !== -1 ? index : null;
        }
      },
      // immediate: true ensures this runs when the component is mounted
      immediate: true,
    },
  },
}
</script>

<style scoped>
.icon-picker .v-card {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.icon-picker .v-card:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1) !important;
}

/* This is the class that Vuetify adds to the selected item's children */
.primary--text .v-card {
  border: 2px solid var(--v-primary-base, #1976D2);
}

@font-face {
  font-family: 'MyFont';
  src: url('/fonts/MaterialSymbolsRounded-Medium.ttf') format('truetype');
}

.my-icon {
  font-family: 'MyFont' !important;
}

</style>
